// extracted by mini-css-extract-plugin
export default {"word-change":"Game_word-change__YGy8b"};